import edinburghCarChargingImage from '../../../assets/images/edinburgh/car-charging.jpg';
import edinburghCityImage from '../../../assets/images/edinburgh/edinburgh-city.jpg';
import edinburghStreetImage from '../../../assets/images/edinburgh/edinburgh-street.jpg';

/** @type {import('./cityLandingPageData').CityData} */
const edinburgh = {
    cityName: 'Edinburgh',
    searchQuery: 'Edinburgh',
    heroHeading: "Haste Ye Back! Find EV Chargers in Edinburgh",
    heroSubheading: "Search for electric vehicle charging points across Edinburgh and the Lothians. From the Royal Mile to Leith, Morningside, and beyond, EVBuddy helps you find your nearest charger and charge with confidence.",
    searchPlaceholder: "Try an Edinburgh postcode, e.g. EH1...",
    networkSection: {
        heading: "Edinburgh's Charging Network at Your Fingertips",
        paragraphs: [
            "Edinburgh has one of the most forward-thinking EV charging networks in Scotland, with public charge points spread across the city and into the wider Lothians.",
            <>Edinburgh City Council are leading a collection of local authorities in the region to expand the network, with estimates for current public <a href="https://www.edinburgh.gov.uk/downloads/file/38002/south-of-scotland-ev-charging-strategy#page=19" target="_blank" rel="noopener noreferrer">charging capacity</a> needing to double across the south of Scotland by 2030.</>,
            "EVBuddy shows you their locations and latest status, giving you confidence in finding an available charger wherever you are in the city.",
        ],
        image: edinburghCityImage,
        imageAlt: "Electric vehicle charging at a public charge point in Edinburgh city centre",
    },
    filterSection: {
        heading: "Find the Right Charger for Your Vehicle",
        paragraphs: [
            "Not all chargers are the same. Whether you need a rapid speed charger for a quick top-up near Waverley Station or a slower overnight charger near your Morningside home, EVBuddy allows you to filter by connector type and charging speed so you always find the right match.",
        ],
        image: edinburghCarChargingImage,
        imageAlt: "EV charging in Edinburgh",
    },
    navigateSection: {
        heading: "Navigate Edinburgh's Streets with Confidence",
        paragraphs: [
            "Driving around Edinburgh shouldn't mean worrying about range anxiety. EVBuddy shows you chargers on an interactive map so you can plan your journey across the city, whether you're navigating the Old Town cobbles, cruising the A720 City Bypass, or heading out towards East Lothian and beyond.",
        ],
        image: edinburghStreetImage,
        imageAlt: "Edinburgh street scene",
    },
    seo: {
        title: "EV Charging Points in Edinburgh | Find Chargers Near You | EVBuddy",
        description: "Find electric vehicle charging points across Edinburgh. Search for public EV chargers in Edinburgh City Centre, Leith, Morningside, Portobello, and across the Lothians with EVBuddy.",
        keywords: "EV charging Edinburgh, electric vehicle chargers Edinburgh, EV charging points Edinburgh, public EV chargers Edinburgh, Edinburgh electric car charging, charge my EV Edinburgh, rapid chargers Edinburgh, Lothians EV chargers",
        canonicalUrl: "https://evbuddy.io/edinburgh",
        ogImage: "https://evbuddy.io/static/media/edinburgh-city.jpg",
        ogDescription: "Find electric vehicle charging points across Edinburgh and the Lothians. Search for public EV chargers with EVBuddy.",
    },
};

export default edinburgh;
